import * as React from "react";
import styled from "styled-components";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import SchedulingFrequencyForm from "report/report-configuration-page/SchedulingFrequencyForm";
import { ListGroupItem, ButtonToolbar } from "components/bootstrap";
import { IconButton, Icon } from "components/common";
import FrequencySummary from "report/report-configuration-page/FrequencySummary";
const Container = styled(ListGroupItem)`
  padding-top: 0;
  padding-bottom: 0;
  min-height: 32px;
`;
const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const OverridesInfo = styled.div`
  padding: 5px 0;
`;
const StyledButtonToolbar = styled(ButtonToolbar)`
  white-space: nowrap;
`;
const SchedulingFrequenciesListItem = ({ schedulingFrequency, onDelete, onUpdate, disabled }) => {
  var _a;
  const { t } = useTranslation("enterprise_report");
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const _onUpdate = (newFrequency) => {
    onUpdate(newFrequency);
    setShowUpdateForm(false);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(FlexContainer, null, /* @__PURE__ */ React.createElement(
    FrequencySummary,
    {
      frequency: schedulingFrequency.frequency,
      frequencyConfiguration: schedulingFrequency.frequency_configuration
    }
  ), /* @__PURE__ */ React.createElement(StyledButtonToolbar, null, /* @__PURE__ */ React.createElement(
    IconButton,
    {
      title: t("scheduling_frequency_item.edit"),
      onClick: () => setShowUpdateForm(true),
      name: "edit_square",
      disabled
    }
  ), /* @__PURE__ */ React.createElement(
    IconButton,
    {
      title: t("scheduling_frequency_item.delete"),
      onClick: onDelete,
      name: "delete",
      disabled
    }
  ))), ((_a = schedulingFrequency == null ? void 0 : schedulingFrequency.frequency_configuration) == null ? void 0 : _a.override_widgets_timerange) && /* @__PURE__ */ React.createElement(OverridesInfo, null, /* @__PURE__ */ React.createElement(Icon, { name: "info" }), /* @__PURE__ */ React.createElement("i", null, " ", t("scheduling_frequency_item.overrides_info")))), showUpdateForm && /* @__PURE__ */ React.createElement(
    SchedulingFrequencyForm,
    {
      onSubmit: _onUpdate,
      onCancel: () => setShowUpdateForm(false),
      title: t("scheduling_frequency_item.edit"),
      submitButtonText: t("scheduling_frequency_item.update_frequency"),
      submitLoadingText: t("scheduling_frequency_item.updating_frequency"),
      schedulingFrequency
    }
  ));
};
export default SchedulingFrequenciesListItem;
